import React from "react";
import clsx from "clsx";

import "./Sidebar.scss";

const Sidebar = (props) => {
  const { children, className } = props;
  return <aside className={clsx(className && className)}>{children}</aside>;
};

export default Sidebar;
